import "./App.css";
import React, { Fragment } from "react";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import Login from "./components/auth/Login";
import Register from "./components/auth/Register";
import Home from "./containers/Home";
import Case from "./containers/case/Case";
import CaseView from "./containers/case/CaseView";
import CaseEdit from "./containers/case/CaseEdit";
import Name from "./containers/masterdata/names/Name";
import NameView from "./containers/masterdata/names/NameView";
import NameEdit from "./containers/masterdata/names/NameEdit";
import Classes from "./containers/masterdata/classes/Classes";
import Event from "./containers/masterdata/events/Event";
import CaseSearch from "./containers/case/CaseSearch";
import Role from "./containers/administrator/Role";
import User from "./containers/administrator/User";
// import NotFound from "./containers/error/NotFound";
// import Alerts from "./containers/layout/Alerts";
import Quotation from "./containers/account/quotations/Quotation";
import QuotationEdit from "./containers/account/quotations/QuotationEdit";
import Invoice from "./containers/account/invoices/Invoice";
import InvoiceEdit from "./containers/account/invoices/InvoiceEdit";
import Expense from "./containers/account/expenses/Expense";
import ExpenseEdit from "./containers/account/expenses/ExpenseEdit";
import AgentPrice from "./containers/account/agentprices/AgentPrice";
import AgentPriceEdit from "./containers/account/agentprices/AgentPriceEdit";
import Payment from "./containers/account/payments/Payment";
import PaymentEdit from "./containers/account/payments/PaymentEdit";

import PrivateRoute from "./components/routing/PrivateRoute";

import AuthState from "./context/auth/AuthState";
import MenuState from "./context/menu/MenuState";
import AlertState from "./context/alert/AlertState";
import setAuthToken from "./utils/setAuthToken";

if (localStorage.token) {
  setAuthToken(localStorage.token);
}

const App = () => {
  return (
    <AuthState>
      <MenuState>
        <AlertState>
          <BrowserRouter>
            <Fragment>
              <Switch>
                <PrivateRoute exact path="/" component={Home} />
                <PrivateRoute exact path="/home" component={Home} />
                <PrivateRoute exact path="/cases" component={Case} />
                <PrivateRoute exact path="/cases/add" component={CaseEdit} />
                <PrivateRoute
                  exact
                  path="/cases/view/:id"
                  component={CaseView}
                />
                <PrivateRoute
                  exact
                  path="/cases/edit/:id"
                  component={CaseEdit}
                />
                <Route exact path="/login" component={Login} />

                <PrivateRoute exact path="/names" component={Name} />
                <PrivateRoute exact path="/names/add" component={NameEdit} />
                <PrivateRoute
                  exact
                  path="/names/view/:id"
                  component={NameView}
                />
                <PrivateRoute
                  exact
                  path="/names/edit/:id"
                  component={NameEdit}
                />

                <PrivateRoute exact path="/classes" component={Classes} />
                <PrivateRoute exact path="/events" component={Event} />

                <Route exact path="/register" component={Register} />
                {/* <Route component={NotFound} /> */}

                <PrivateRoute exact path="/casesearch" component={CaseSearch} />
                <PrivateRoute exact path="/roles" component={Role} />
                <PrivateRoute exact path="/users" component={User} />

                <PrivateRoute exact path="/quotations" component={Quotation} />
                <PrivateRoute exact path="/quotations/add" component={QuotationEdit} />
                <PrivateRoute exact path="/invoices" component={Invoice} />
                <PrivateRoute exact path="/invoices/add" component={InvoiceEdit} />
                <PrivateRoute exact path="/expenses" component={Expense} />
                <PrivateRoute exact path="/expenses/add" component={ExpenseEdit} />
                <PrivateRoute exact path="/agentprices" component={AgentPrice} />
                <PrivateRoute exact path="/agentprices/add" component={AgentPriceEdit} />
                <PrivateRoute exact path="/payments" component={Payment} />
                <PrivateRoute exact path="/payments/add" component={PaymentEdit} />
              </Switch>
            </Fragment>
          </BrowserRouter>
        </AlertState>
      </MenuState>
    </AuthState>
  );
};

export default App;
